import { IS_NO_IP_ONLY_HTTPS } from 'constants/constants';
import { required } from 'utils/errorsTextHelper';
import * as yup from 'yup';

export const generalSchema = yup.object().shape({
  storeTabName: yup.string().required(required('Store Tab Title')),
  logo: yup.string().required(required('Logo')),
  favicon: yup.string().required(required('Favicon')),
  backgroundImageMobile: yup.string().required(required('Background image')),
  backgroundImageDesktop: yup.string().required(required('Background image')),
  storeSaleImage: yup.string().notRequired(),
  loaderAnimation: yup.string(),
  font: yup.string().required(required('Font')),
  footer: yup.object().shape({
    imageMobile: yup.string().notRequired(),
    imageDesktop: yup.string().notRequired(),
    appstoreLink: yup
      .string()
      .test(
        'Must be a valid URL, starting with https://, and not an IP address',
        'Must be a valid URL, starting with https://, and not an IP address',
        (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
      )
      .notRequired(),
    googlePlayLink: yup
      .string()
      .test(
        'Must be a valid URL, starting with https://, and not an IP address',
        'Must be a valid URL, starting with https://, and not an IP address',
        (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
      )
      .notRequired(),
    privacyPolicyUrl: yup
      .string()
      .test(
        'Must be a valid URL, starting with https://, and not an IP address',
        (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
      ),
    termsAndConditionsUrl: yup
      .string()
      .test(
        'Must be a valid URL, starting with https://, and not an IP address',
        (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
      ),
    supportLink: yup
      .string()
      .test(
        'Must be a valid URL, starting with https://, and not an IP address',
        'Must be a valid URL, starting with https://, and not an IP address',
        (value: any) => IS_NO_IP_ONLY_HTTPS(value as string)
      )
      .notRequired(),
    supportParams: yup
      .object()
      .shape({
        playerIdParamName: yup
          .string()
          .test(
            'param-name',
            'Use only letters, numbers, underscores, and hyphens',
            (value) =>
              value === undefined ||
              value === '' ||
              /^[a-zA-Z0-9_-]+$/.test(value as string)
          )
          .notRequired(),
        playerNameParamName: yup
          .string()
          .test(
            'param-name',
            'Use only letters, numbers, underscores, and hyphens',
            (value) =>
              value === undefined ||
              value === '' ||
              /^[a-zA-Z0-9_-]+$/.test(value as string)
          )
          .notRequired()
      })
      .notRequired(),
    openLinksInNewTab: yup.boolean(),
    showCookieSettings: yup.boolean()
  }),
  maintenanceModeRichText: yup.object().shape({
    text: yup.string().notRequired(),
    fontColor: yup.string().notRequired()
  }).notRequired(),
});
